import {
  restoreLocalStorageSnapshot,
  TWO_FACTOR_PROMPT_DISMISSED_KEY_PREFIX,
} from '../../../../helpers/persistentLocalStorage';

export { TWO_FACTOR_PROMPT_DISMISSED_KEY_PREFIX };
export { snapshotPersistentPromptKeys } from '../../../../helpers/persistentLocalStorage';

export const get2faSetupPromptDismissedKey = (userId: string) =>
  `${TWO_FACTOR_PROMPT_DISMISSED_KEY_PREFIX}_${userId}`;

export const hasSeen2faSetupPrompt = (userId: string | undefined) => {
  if (!userId) return false;
  return localStorage.getItem(get2faSetupPromptDismissedKey(userId)) === 'true';
};

/** @deprecated Use hasSeen2faSetupPrompt */
export const hasDismissed2faSetupPrompt = hasSeen2faSetupPrompt;

export const mark2faSetupPromptSeen = (userId: string | undefined) => {
  if (!userId) return;
  localStorage.setItem(get2faSetupPromptDismissedKey(userId), 'true');
};

/** @deprecated Use mark2faSetupPromptSeen */
export const mark2faSetupPromptDismissed = mark2faSetupPromptSeen;

export const restorePersistentPromptKeys = (
  snapshot: Record<string, string>,
) => {
  restoreLocalStorageSnapshot(snapshot);
};

export const get2faSecurityTabIndex = () =>
  localStorage.getItem('userHasPin') ? 2 : 3;

export const navigateTo2faSetup = (
  navigate: (path: string) => void,
  openSetupFlow = true,
) => {
  sessionStorage.setItem('lastSettingsTab', '4');
  sessionStorage.setItem(
    'lastSecurityTab',
    get2faSecurityTabIndex().toString(),
  );

  if (openSetupFlow) {
    sessionStorage.setItem('open2faSetup', 'true');
  } else {
    sessionStorage.removeItem('open2faSetup');
  }

  navigate('/app/settings?view=security');
};
